exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".a-logo[data-v-14e5a3a2]{display:-ms-inline-flexbox;display:inline-flex}\n", ""]);

// exports
